module.exports = __webpack_public_path__ + "static/media/otto-footer.a29d4569.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/img/otto-footer.jpg
// module id = 289
// module chunks = 0